import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import { Snackbar, Alert } from "@mui/material";
import HeaderTags from "./components/HeaderTags";

const Tags = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor: snackbar.severity === "success" ? "#f0fff4" : "#fff5f5",
            color: snackbar.severity === "success" ? "#276749" : "#c53030",
            border: snackbar.severity === "success" ? "1px solid #c6f6d5" : "1px solid #fed7d7",
            boxShadow: 2,
            "& .MuiAlert-icon": {
              color: snackbar.severity === "success" ? "#276749" : "#c53030",
            },
          }}
        >
          <MDTypography variant="body1" fontWeight="bold">
            {snackbar.severity === "success" ? "¡Éxito!" : "Error"}
          </MDTypography>
          <MDTypography variant="body2">{snackbar.message}</MDTypography>
        </Alert>
      </Snackbar>

      <HeaderTags
        onError={(error) => {
          if (error) {
            setSnackbar({
              open: true,
              message: error,
              severity: "error",
            });
          }
        }}
      />
    </DashboardLayout>
  );
};

export default Tags;
